var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6465 11.512C16.6385 10.0372 17.3055 8.92403 18.6558 8.10423C17.9003 7.02323 16.759 6.42848 15.252 6.31194C13.8254 6.19942 12.2662 7.14379 11.6956 7.14379C11.0928 7.14379 9.71041 6.35213 8.62539 6.35213C6.38302 6.3883 4 8.1404 4 11.7049C4 12.7578 4.19289 13.8455 4.57868 14.968C5.09306 16.4428 6.94964 20.0595 8.8866 19.9993C9.89929 19.9751 10.6146 19.2799 11.9327 19.2799C13.2106 19.2799 13.8737 19.9993 15.0029 19.9993C16.9559 19.9711 18.6357 16.6839 19.126 15.2051C16.5058 13.9714 16.6465 11.5884 16.6465 11.512ZM14.372 4.91348C15.469 3.61145 15.3686 2.42597 15.3364 2C14.368 2.05626 13.2468 2.65905 12.6078 3.40249C11.9046 4.19817 11.4906 5.18272 11.5791 6.29185C12.6279 6.37222 13.5843 5.83373 14.372 4.91348Z",
    fill: "#1E2432"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.cb04183142b0089e69b0e451f38a4ef9.svg";
export { ForwardRef as ReactComponent };